import React from 'react'
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Container from 'react-bootstrap/Container';
import firebase, {auth} from './Firebase';

const localizer = momentLocalizer(moment);

function CalendarView(){
    const [events, setEvents] = React.useState([{
        id: 6,
        title: 'Meeting',
        start: new Date(2021, 3, 7, 10, 30, 0, 0),
        end: new Date(2021, 3, 7, 12, 30, 0, 0),
        desc: 'Pre-meeting meeting, to prepare for the meeting',
      }])
    console.log(events)
    //read events from firebase 
    React.useEffect(()=>{
        // add listener to the uid log space 
        console.log(auth.currentUser.uid);
        var dfRefObj = firebase.database().ref().child('/calendarEvents/' + auth.currentUser.uid).limitToLast(25);
        dfRefObj.on('value', snap =>{
            console.log(snap.val())
            const cur_events = snap.val()
            const _events = []
            for (let e in cur_events){
                _events.push({
                    title : cur_events[e].title,
                    start: new Date(cur_events[e].start),
                    end : new Date(cur_events[e].end)
                })

            }
            setEvents(_events)
            console.log(events)

        })
    }, [])

    return (
       <Container>
           <Calendar
          localizer={localizer}
          defaultDate={new Date()}
          defaultView="week"
          events={events}
          style={{ height: "75vh" , marginTop:"40px"}}
        />
       </Container>
        
      

    )
}
// class App extends Component {
//   state = {
//     events: [
//       {
//         start: moment().toDate(),
//         end: moment()
//           .add(1, "days")
//           .toDate(),
//         title: "Some title"
//       }
//     ]
//   };




export default CalendarView